import { Fragment, useCallback } from 'react';
import { Link, useParams } from 'react-router-dom';

import { LeftOutlined, SmileOutlined as MoodIcon } from '@ant-design/icons';
import { Button, Col, Row, Spin, Typography } from 'antd';

import { formatDate } from 'helpers/date';
import NoDangerouslyHTML from 'v2/components/Shared/NoDangerouslyHTML';
import { useNewzzInfo } from 'v2/hooks/useNewzz';

import { openModalBF } from './modalBF';

interface IProps {
  notProductRecovering: number;
}

const InfoNewzz = ({ notProductRecovering }: IProps) => {
  const { newzzId } = useParams<{ newzzId: string }>();

  const { currentNewzz, isLoading } = useNewzzInfo(Number(newzzId));

  const handleClick = useCallback(() => {
    openModalBF(notProductRecovering);
  }, [notProductRecovering]);

  return (
    <div className='w-full'>
      <Link to='/producer/news/list'>
        <LeftOutlined style={{ fontSize: 16, lineHeight: '21px' }} /> Voltar para news
      </Link>
      <Row
        justify='center'
        align='middle'
        style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}
      >
        {currentNewzz?.title && (
          <h2 className='mb-[0.5rem] text-center text-base text-[1.5rem] font-bold! text-[#192542]'>
            {currentNewzz?.title}
          </h2>
        )}
        <Typography.Text className='text-right text-sm opacity-50' style={{ fontSize: '16px' }}>
          Publicado em: {formatDate(currentNewzz?.created_at, 'dd/MM/yyyy')}
        </Typography.Text>
      </Row>

      {isLoading ? (
        <div className='flex h-full items-center justify-center py-8'>
          <Spin size='large' />
        </div>
      ) : currentNewzz ? (
        <Row justify='center' align='middle'>
          <Col xs={24} md={20} lg={20} className='rounded-[5px]! p-6 [&_img]:mx-auto [&_img]:block [&_img]:max-w-full'>
            <NoDangerouslyHTML html={currentNewzz.content} />
            {(currentNewzz.id === 210 && notProductRecovering > 0) ||
              (true && (
                <Fragment>
                  <Col span={24}>
                    <p>
                      Se você tem interesse em ativar a opção de RECUPERAÇÃO DE VENDAS PERDIDAS em TODOS os seus
                      produtos, clique no link abaixo:
                    </p>
                  </Col>
                  <Col span={24}>
                    <Button
                      type='primary'
                      onClick={handleClick}
                      className='m-2 h-auto! w-full bg-[#009358]! py-1! whitespace-normal! text-white hover:bg-[#007A49]!'
                      icon={<MoodIcon className='mr-2' />}
                      size='large'
                    >
                      QUERO ATIVAR A OPÇÃO DE RECUPERAÇÃO DE VENDAS PERDIDAS EM TODOS OS MEUS PRODUTOS
                    </Button>
                  </Col>
                </Fragment>
              ))}
          </Col>
        </Row>
      ) : null}
    </div>
  );
};

export default InfoNewzz;
